import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

export const IconAssetLinkItemSchema = buildEntrySchemaFor('iconAssetLinkItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      heading: RichTextSchema,
      description: RichTextSchema,
      href: z.string().optional(),
      label: z.string().optional(),
      icon: z.string().optional(),
      assetType: z.enum(['Image', 'Uploaded Video', 'External Video']).optional(),
      optionImage: AssetSchema.optional(),
      optionVideo: AssetSchema.optional(),
      optionPoster: AssetSchema.optional(),
      autoplay: z.boolean().optional(),
      videoSource: z.string().optional(),
    }),
  ),
})
export type IconAssetLinkItem = z.infer<typeof IconAssetLinkItemSchema>
